import React from 'react';

// Styled Components
import { Container, MainLayout, CarouselContainer, ServiceCardWrapper } from './styles';

// Warwick Components
import HeaderBar from './components/HeaderBar';
import ServiceCard from './components/ServiceCard';
import BottomNavBar from './components/BottomNavBar';
import MenuId from 'enum/menu-id.enum';

import Storages from 'storages';
import { bottomNavigationItems } from 'utils/menuList';

import { translate as t } from 'utils/i18n';

export default function Warwick(props) {
  const [navItems] = React.useState(bottomNavigationItems);

  // Helper function to get visible cards in circular arrangement
  const getVisibleCards = (cards, activeIndex) => {
    if (cards.length === 0) return [];

    const n = cards.length;
    activeIndex = activeIndex % n;
    const prevIndex = (activeIndex - 1 + n) % n;
    const nextIndex = (activeIndex + 1) % n;

    return [
      Object.assign({}, cards[prevIndex], { position: 'prev', originalIndex: prevIndex }),
      Object.assign({}, cards[activeIndex], { position: 'current', originalIndex: activeIndex }),
      Object.assign({}, cards[nextIndex], { position: 'next', originalIndex: nextIndex }),
    ];
  };

  var serviceCards = (props.mainMenuList || []).map(function (item) {
    return Object.assign({}, item, {
      id: item.id,
      title: item.title || '',
      description: item.description || '',
      backgroundImage: item.image !== null && item.image !== undefined ? item.image : null,
    });
  });

  return (
    <Container>
      {/* Header Bar */}
      <HeaderBar />

      {/* Main Layout */}
      <MainLayout>
        <CarouselContainer>
          {getVisibleCards(serviceCards, props.focusedListIndex === 0 ? props.focusedIndex : 0).map(
            (card) => (
              <ServiceCardWrapper
                key={`${card.id}`}
                active={card.position === 'current'}
                position={card.position}
                totalCards={serviceCards.length}
              >
                <ServiceCard
                  title={
                    card.id == MenuId.PORTAL
                      ? t('Portal.organization_info').replace(
                          '{organization}',
                          Storages.getOrganizationName()
                        ) || card.title
                      : card.title
                  }
                  description={card.description}
                  backgroundImage={
                    card.id == MenuId.PORTAL
                      ? Storages.getGroupWallpapers()[0]?.image ?? card.backgroundImage
                      : card.backgroundImage
                  }
                  active={card.position === 'current'}
                  onClick={() => props.updateMenuList(card.originalIndex, true, true)}
                  className='main-menu-button'
                />
              </ServiceCardWrapper>
            )
          )}
        </CarouselContainer>
      </MainLayout>

      {/* Bottom Navigation */}
      <BottomNavBar
        items={navItems}
        activeIndex={props.focusedListIndex === 1 ? props.focusedIndex : -1}
        onItemClick={props.onBottomNavClick}
      />
    </Container>
  );
}
